<template>
    <div class="income_box">
        <div class="list" v-if="subRouteNames.includes('/detectionSummary')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(255, 144, 73, 0.4);background:rgba(255, 144, 73, 0.4) " @click="OperationDataStatistics('detectionSummary')">
                <img src="../../assets/image/dataReport_1.png" alt="">
                <div class="name"><span>检测汇总月度统计</span></div>
                <div class="content"><span>统计当月检测台数、检出台数、检出项目数、成交项目数等合计项</span></div>
            </a>
        </div>
        <div class="list" v-if="subRouteNames.includes('/checkDeal')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(73, 171, 255, 0.4);background:rgba(73, 171, 255, 0.4)" @click="OperationDataStatistics('checkDeal')">
                <img src="../../assets/image/dataReport_2.png" alt="">
                <div class="name"><span>检出成交项目统计</span></div>
                <div class="content"><span>统计某时段各检测项目的检测覆盖率、检出率、成交率等</span></div>
            </a>
        </div>
        <div class="list" v-if="subRouteNames.includes('/SADealSummany')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(239, 175, 96, 0.4);background:rgba(239, 175, 96, 0.4)" @click="OperationDataStatistics('SADealSummany')">
                <img src="../../assets/image/dataReport_4.png" alt="">
                <div class="name"><span>服务顾问成交项目</span></div>
                <div class="content"><span>统计某服务顾问的检测达成度绩效：检出项目数、检出率、成交项目数、成交率等</span></div>
            </a>
        </div>
        <div class="list" v-if="subRouteNames.includes('/modelDealSummany')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(74, 223, 147, 0.4);background:rgba(74, 223, 147, 0.4)" @click="OperationDataStatistics('modelDealSummany')">
                <img src="../../assets/image/dataReport_5.png" alt="">
                <div class="name"><span>检出车型成交统计</span></div>
                <div class="content"><span>统计服务顾问检出车型的检测台次、检出台次、成交台次等</span></div>
            </a>
        </div>
        <div class="list" v-if="subRouteNames.includes('/salesDealSummany')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(255, 144, 73, 0.4);;background:rgba(255, 144, 73, 0.4)" @click="OperationDataStatistics('salesDealSummany')">
                <img src="../../assets/image/report_1.png" alt="">
                <div class="name"><span>项目成交统计</span></div>
                <div class="content"><span>统计某时段各检测项目的单项检测渗透率、检出异常占比、已销售合计、总成交率排名等</span></div>
            </a>
        </div>
        <div class="list" v-if="subRouteNames.includes('/dossierManager')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(73, 171, 255, 0.4);background:rgba(73, 171, 255, 0.4)" @click="OperationDataStatistics('dossierManager')">
                <img src="../../assets/image/report_2.png" alt="">
                <div class="name"><span>检测报告查询</span></div>
                <div class="content"><span>查询查询检测车辆的档案详情：括车牌、检测详情、检测报告二维码</span></div>
            </a>
        </div>
        <div class="list" v-if="subRouteNames.includes('/lossSale')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(239, 175, 96, 0.4);background:rgba(239, 175, 96, 0.4)" @click="OperationDataStatistics('lossSale')">
                <img src="../../assets/image/report_4.png" alt="">
                <div class="name"><span>失销统计分析</span></div>
                <div class="content"><span>统计所有检出车型未能销售成交的清单，可以按照登记原因及SA分项统计</span></div>
            </a>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        subRouteNames:[]
      };
    },
    created(){
      let navList = JSON.parse(sessionStorage.getItem("navList")).data
      console.log(navList)
      let filterItem = navList.filter(item => {
        return item.routeName === '/OperationDataStatistics'
      })
      const subRouteNames = filterItem[0].subMenu.map(obj => obj.subRouteName);
      console.log(subRouteNames)
      this.subRouteNames = subRouteNames


    },
    methods:{
      OperationDataStatistics(item){

        this.$router.replace({name:item})
        let routeInfo ={
          path: `/${item}`
        }
        sessionStorage.setItem("routeInfo", JSON.stringify(routeInfo));

        let showInfo = {
          showMenu: true,
          showData: false,
          showChart: true,
          showSystem: false,
          active_tab:'3',
          routeName: `/${item}`
        }
        sessionStorage.setItem("showInfo", JSON.stringify(showInfo));
      },

      detectZoom() {
        let ratio = 0
        const screen = window.screen
        const ua = navigator.userAgent.toLowerCase()
        if (window.devicePixelRatio !== undefined) {
          ratio = window.devicePixelRatio
        } else if (~ua.indexOf('msie')) {
          if (screen.deviceXDPI && screen.logicalXDPI) {
            ratio = screen.deviceXDPI / screen.logicalXDPI
          }
        } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
          ratio = window.outerWidth / window.innerWidth
        }
        if (ratio) {
          ratio = Math.round(ratio * 100)
        }
        // return ratio
        if(ratio*1 > 100 && ratio*1 <= 125){
          window.onload = window.onresize = function () {
            document.body.style.zoom = 0.8
          };
          // window.resizeBy(50, 0);
        }else if(ratio*1 > 125 && ratio*1 <= 150){
          window.onload = window.onresize = function () {
            document.body.style.zoom = 0.6
          };
        }else if(ratio*1 > 150){
          window.onload = window.onresize = function () {
            document.body.style.zoom = 0.5
          };
        }
      },
    }
  };
</script>

<style lang="less" scoped>
    .income_box {
        overflow: hidden;
        padding-top: 20px;
        padding-left: 5px;
        .list {
            padding: 0 15px 40px 15px;
            float: left;
            max-width: 360px;
            width: 17vw;
            height: 21vw;
            /*background: linear-gradient(132.59deg, #FF3B94 11.42%, #FFB02E 96.37%);*/
            .item {
                width: 100%;
                /*height: 400px;*/
                display: block;
                border-radius: 32px;
                overflow: hidden;
                position: relative;
                img {
                    width: 100%;
                }
                .name {
                    position: absolute;
                    top: 50%;
                    width: 100%;
                    text-align: center;
                    span {
                        font-family: 'PingFang SC';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 140%;
                        line-height: 39px;
                        text-align: center;
                        color: #FFFFFF;
                    }
                }
                .content {
                    position: absolute;
                    left: 5%;
                    top: 64.75%;
                    width: 90%;
                    right: 5%;
                    span {
                        width: 100%;
                        height: 86px;
                        display: block;
                        font-family: 'PingFang SC';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 70%;
                        line-height: 200%;
                        text-align: left;
                        color: #FFFFFF;
                        /*transform: scale(0.7);*/
                        /*-webkit-transform: scale(0.7);*/

                    }
                }
            }
        }
    }
</style>
